export default [
    { key: 'name', label: 'Nombre' },
    { key: 'profile.name', label: 'Perfil' },
    { key: 'document', label: 'Documento' },
    { key: 'email', label: 'E-mail' },
    { key: 'username', label: 'Nombre de usuario' },
    { key: 'city.name', label: 'Ciudad' },
    { key: 'actions', label: '' },
]